<form [formGroup]="searchItem" class="filterable-table">
    <input #input [ngClass]="{'active': showList}" [placeholder]="getPlaceholder()" (keydown.arrowup)="select(true)"
        (keydown.arrowdown)="select(false)" (keydown.enter)="selectItemEnter()" (click)="showList=!showList"
        formControlName="des">
    <span *ngIf="!searchItem.disabled" class="enabled">
        <i [ngClass]="showList ? 'fas fa-angle-up': 'fas fa-angle-down'"
            (click)="searchItem.disabled ? $event.stopPropagation() : showList=!showList; input.focus();"></i>
    </span>
    <span *ngIf="searchItem.disabled" class="disabled">
        <i [ngClass]="showList ? 'fas fa-angle-up': 'fas fa-angle-down'"
            (click)="searchItem.disabled ? $event.stopPropagation() : showList=!showList; input.focus();"></i>
    </span>
    <content *ngIf="showList">
        <li *ngIf="selectedItem.value" class="selected">{{getSelectedItem()}}
            <i class="fas fa-times" (click)="reset()"></i>
        </li>
        <ng-container *ngIf="!selectedItem.value">
            <table *ngIf="!selectedItem.value">
                <thead>
                    <tr>
                        <th class="string" *ngFor="let column of columns">{{column}}</th>
                    </tr>
                </thead>
                <tbody *ngFor="let item of filteredList; let i = index;">
                    <tr id="item{{i}}" *ngIf="item !== selectedItem.value" [ngClass]="{'active': i == selected}"
                        [class.selected]="i == selected" (click)="selectItem(item)" tabIndex="-1">
                        <td class="string" *ngFor="let property of properties">{{item[property]}}</td>
                    </tr>
                </tbody>
            </table>
        </ng-container>
        <li *ngIf="(filteredList && filteredList.length === 0) && !selectedItem.value">No se han encontrado datos.</li>
    </content>
</form>